Ext.ns('mx');

/**
 * Функционал для локализации
 */
mx.Localization = {
    localize: function(local, localizationDescriptor) {
        //Виджеты
        if (localizationDescriptor.getWidgets) {
            this.localizeWidgets(local, localizationDescriptor.getWidgets());
        }

        //навигация
        if (localizationDescriptor.getNavigables) {
            this.localizeNavigation(local, localizationDescriptor.getNavigables());
        }

        //дополнительная локализация, которая может потребоваться
        if (localizationDescriptor.customLocalization) {
            localizationDescriptor.customLocalization(this, local);
        }
    },

    //private
    localizeWidgets: function(local, widgets) {
        for (var j in local) {
            if (widgets.indexOf(j) > -1) {
                var obj = this.stringToObject(j);
                if (obj) {
                    if (obj.prototype.labels) {
                        Ext.apply(obj.prototype.labels, local[j]);
                    } else {
                        Ext.override(obj, {
                            labels: local[j],
                        });
                    }
                }
            }
        }
    },

    //private
    localizeNavigation: function(local, navigables) {
        for (var j in local) {
            if (j == 'mx.app.core.navTitles') {
                if (MXAT && MXAT.getLocalisationMechanismVersion() >= 1.3) {
                    continue; // localisation mechanism 1.3 doesn't need localisation of navigables
                }
                for (var k in local[j]) {
                    var name = this.replaceAll(k, '_', '.');
                    if (navigables.indexOf(name) > -1) {
                        var obj = this.stringToObject(name);
                        if (obj && obj.navigation) {
                            obj.navigation.title = local[j][k];
                        }
                    }
                }
            }
        }
    },

    replaceAll: function(string, pcFrom, pcTo) {
        var i = string.indexOf(pcFrom);
        var c = string;

        while (i > -1) {
            c = c.replace(pcFrom, pcTo);
            i = c.indexOf(pcFrom);
        }
        return c;
    },

    stringToObject: function(string) {
        var tmp = string.split('.');
        var O = [];
        for (var i = 0; i < tmp.length; i++) {
            O.push(tmp[i]);
            var obj = eval(O.join('.')); // todo: inspect possible security leak
            if (!obj) {
                return null;
            }
        }
        return eval(O.join('.'));
    },
};
